import { extractTokenInfo } from '@/utils/auth';

export default {
  install(app, options) {
    app.config.globalProperties.$getTokenInfo = () => {
      return extractTokenInfo()
    }
  },
}